import React from "react";
import "./FormPlanos.scss";
import Container from "@mui/material/Container";
import Ilustracao from "../../../assets/images/planos/ilustracao.png";
import { useState } from "react";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";
import Api from "../../../Api";
const FormPlanos = () => {
  function sendEmail(e) {
    e.preventDefault();

    const data = {
      nome: nome,
      telefone: telefone,
      email: email,
      empresa: empresa,
      mensagem: mensagem,
    };

    Api.post("criar", data).then(
      (res) => {
        emailjs
          .sendForm(
            "service_jqezxqg",
            "template_irym1vf",
            e.target,
            "user_s58UnWwl1TmFQ2U2b7F6H"
          )
          .then(
            (result) => {
              e.target.reset();
              setNome("");
              setEmail("");
              setMensagem("");
              setTelefone("");
              setEmpresa("");
            },
            (error) => {
              console.log(error);
            }
          );
        Swal.fire({
          title: "Sucesso!",
          text: "Mensagem enviada com sucesso!",
          icon: "success",
          confirmButtonText: "Ok",
        });
      },
      (err) => {
        Swal.fire({
          title: "Erro!",
          text: "Falha ao enviar mensagem! Entre em contato com o suporte.",
          icon: "error",
          confirmButtonText: "Ok",
        });
        console.log(err);
      }
    );
  }

  const [nome, setNome] = useState("");
  const [telefone , setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [mensagem, setMensagem] = useState("");
  
  return (
    <>
      <div className="view-form-planos">
        <Container>
          <div className="ilustracao-planos">
            <img src={Ilustracao} alt="Ilustracao" />
          </div>
          <div className="entre">
            <strong>Entre em contato conosco</strong> <br />
            temos uma solução perfeita para você ;)
          </div>
          <form onSubmit={sendEmail}>
            <input
              type="text"
              placeholder="Nome"
              name="nome"
              value={nome}
              onChange={(e) => {
                setNome(e.target.value);
              }}
              required
            />{" "}
            <br />
            <input
              type="text"
              placeholder="Telefone"
              name="telefone"
              value={telefone}
              onChange={(e) => {
                setTelefone(e.target.value);
              }}
              required
            />{" "}
            <br />
            <input
              type="email"
              placeholder="Email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              required
            / >{" "}
            <br />
            <input

              type="text"
              placeholder="Empresa"
              name="empresa"
              value={empresa}
              onChange={(e) => {
                setEmpresa(e.target.value);
              }}
              required
            / >{" "}
            <br />
            <textarea
              name="mensagem"
              id=""
              cols="30"
              rows="10"
              placeholder="Mensagem"
              value={mensagem}
              onChange={(e) => {
                setMensagem(e.target.value);
              }}
            ></textarea>
            <div className="botao">
              <button className={!nome || !email || !mensagem ? 'desabilitado' : ''} >Enviar</button>
            </div>
          </form>
        </Container>
      </div>
    </>
  );
};

export default FormPlanos;
